import React, { useEffect, useRef, useState } from "react";
import "../css/details.scss";
import Header from "./common/Header";
import Footer from "./common/Footer";
import CampaignPage from "./CampaignPage";
import Loading from "./common/Loading";
import { sendMessage } from "../apis/SendMessageAPI";
import { BASE_URL } from "../constans/ApiEndpointConstants";
import LocalStorageUtil from "../utils/localStorageUtil";
import { PixelWithEvent } from "./common/PixelWithEvent ";
import * as FacebookAPI from "../apis/FacebookAPI";
import Cookies from "js-cookie";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getDetails } from "../apis/GetDetails";
import { parseDonationUrl, generateDonationUrl } from "../utils/urlUtils";

const Details = () => {
  const storedAd = LocalStorageUtil.getAd();
  const ad = storedAd || "donation";
  const { name_id } = useParams();
  const id = parseDonationUrl(name_id);
  const [detailsData, setDetailsData] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [pixel, setPixel] = useState(null);
  const [fbqToken, setFbqToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDetails = async () => {
      setLoading(true);
      try {
        const res = await getDetails(id);
        const payload = res?.data;
        setDetailsData(payload);

        setPixel(payload?.pixel);
        setFbqToken(payload?.fbq_token);
      } catch (error) {
        console.error("Failed to fetch details:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDetails();
  }, [id]);

  // 如果 detailsData 的标题与当前 URL 不一致，使用最新标题修正 URL（replace，避免回退循环）
  useEffect(() => {
    if (!detailsData) return;
    const canonicalPath = generateDonationUrl(detailsData);
    if (!canonicalPath) return;
    if (location && location.pathname !== canonicalPath) {
      navigate(canonicalPath, { replace: true });
    }
  }, [detailsData, location, navigate]);

  //event_id，要去重，一天之内用一个，存cookie
  const getEventId = (eventType) => {
    // 根据事件类型使用不同的cookie名
    const cookieName = `fb_event_id_${eventType}`;

    let storedEventId = Cookies.get(cookieName);
    if (storedEventId) {
      return storedEventId;
    } else {
      // 使用 10 位随机数字作为 event_id
      const newEventId = Math.round(Math.random() * 10000000000).toString();
      Cookies.set(cookieName, newEventId, { expires: 1 }); // 存储1天
      return newEventId;
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // 随机生成六位字符（包含数字和字母）
  const generateRandomCode = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 6; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    return result;
  };

  // 获取或生成 userid
  let userid = localStorage.getItem("userid");
  if (!userid) {
    userid = generateRandomCode();
    localStorage.setItem("userid", userid);
  }

  useEffect(() => {
    const userid = localStorage.getItem("userid");
    const message = `${BASE_URL} [Details page]:id=${id}:ad=${ad}:userid=${userid}`;
    sendMessage(message);
  }, [id, ad]);

  // 确保 ViewContent 只触发一次
  const hasTriggeredViewContent = useRef(false);

  useEffect(() => {
    const triggerViewContent = () => {
      if (hasTriggeredViewContent.current) return;
      hasTriggeredViewContent.current = true;
      const event_id = getEventId("ViewContent");
      // 构建 eventData
      const eventData = {
        content_ids: ["donation"],
        content_name: "View Hero donation",
        content_category: "donation",
        value: 0,
        currency: "jpy",
        num_items: 0,
        contents: [],
      };

      PixelWithEvent("ViewContent", event_id);
      // 调用 EventsAll (通过 FacebookAPI.Facebook)
      if (pixel && fbqToken) {
        FacebookAPI.Facebook(
          fbqToken,
          pixel,
          event_id,
          "ViewContent",
          eventData
        );
      }
    };

    // 停留超过 8 秒触发
    const timer = setTimeout(() => {
      triggerViewContent();
    }, 8000);

    // 滚动页面触发 (超过 50px)
    const handleScroll = () => {
      if (window.scrollY > 50) {
        triggerViewContent();
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [pixel, fbqToken]);

  if (loading) {
    return (
      <div className="main_box">
        <Loading />
      </div>
    );
  }

  return (
    <div className="main_box">
      <Header />

      <CampaignPage detailsData={detailsData} />
      <Footer />
    </div>
  );
};

export default Details;
